import BigNumber from 'bignumber.js';

export type OpenPositionFeeProps = {
  openFeeP: number;
  lvTokenDiscountP: number;
  isPayLVToken: boolean;
  positionSize: BigNumber;
};

export type OpenPositionFee = {
  base: BigNumber;
  final: BigNumber;
};

export const getOpenPositionFee = ({
  openFeeP,
  isPayLVToken,
  lvTokenDiscountP,
  positionSize,
}: OpenPositionFeeProps): OpenPositionFee => {
  const baseFee = positionSize.multipliedBy(openFeeP);
  const fee = {
    base: baseFee,
    final: baseFee,
  };
  if (isPayLVToken && lvTokenDiscountP && lvTokenDiscountP > 0) {
    fee.final = baseFee.multipliedBy(1e5 - lvTokenDiscountP).dividedBy(1e5).plus(0.01);
  }
  
return fee;
};